import { signOut } from '@/services/authentication-service/authentication.service';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useJWT } from '../use-jwt/use-jwt';
import { clearSessionState } from '@/services/session/clear-session-state';

export function useLogout() {
  const navigate = useNavigate();
  const { removeToken } = useJWT();
  const queryClient = useQueryClient();

  const { mutateAsync: logout } = useMutation({
    mutationFn: signOut,
    onMutate: () => {
      // Closes the sockets and resets the persisted stores too. A socket is bounded only by
      // the session's expiry, so signing out does not close it on its own.
      clearSessionState();
      // Also through the hook, so the mounted useStorage state drops with the key. The
      // interceptor's path cannot do this and relies on its full reload instead.
      removeToken();
      navigate('/sign-in');

      setTimeout(() => {
        queryClient.clear();
      }, 0);
    },
    onError: () => {},
  });

  return { logout };
}
